<template>
    <main>
        <section class="hero-wrap overflow-hidden">
            <div class="hero-content d-flex" style="min-height: 600px">
                <div class="container py-4">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-7 d-none d-lg-block text-center text-lg-left pl-lg-4">
                            <div class="my-5 pb-4 pb-lg-0 w-lg-75 w-100 mx-auto">
                                <h5 class="text-5 fw-400 text-black-50 mb-4" data-aos="slide-up">
                                    {{ service ? 'Buy Online' : 'Welcome to Magetsi' }}
                                </h5>
                                <h1 class="text-12 font-weight-700 text-primary mb-3" data-aos="slide-up"
                                    data-aos-delay="300">
                                    <span>{{ service || 'Experience Lightning Fast Bill Payments!' }}</span>
                                </h1>
                                <p class="text-4 text-black-50 mb-4" data-aos="slide-up" data-aos-delay="500">
                                    Magetsi is a digital omni-channel platform that provides an array of payment
                                    services through web, WhatsApp, Facebook, and other channels.
                                </p>
                                <div class="text-black-50" data-aos="slide-up" data-aos-delay="700">
                                    <p> Pay with </p>
                                    <div class="d-flex align-items-center mb-4 flex-wrap">
                                        <img class="payment-logo" src="/img/EcoCash.svg" alt="">
                                        <img class="payment-logo" src="/img/payments/mastercard.png" alt="">
                                        <img class="payment-logo" src="/img/payments/visa.png" alt="">
                                        <img class="payment-logo" src="/img/payments/apple-pay.png" alt="">
                                        <img class="payment-logo" src="/img/payments/gpay.png" alt="">
                                        <img class="payment-logo" src="/img/payments/unionpay.png" alt="">
                                        <img class="payment-logo" src="/img/payments/diners-club.png" alt="">
                                        <img class="payment-logo" src="/img/payments/american-express.png" alt="">
                                    </div>
                                    <div data-aos="slide-up" data-aos-delay="900" class="d-flex align-items-center"
                                         data-aos-once="true">
                                        <i class="fa fa-lock text-primary mr-3"></i>
                                        <span>Guaranteed <strong>safe & secure</strong> checkout</span>
                                        <img style="width: 140px" src="/img/payments/powered-by-stripe.svg" alt="">
                                    </div>
                                    <p class="mb-2" style="margin-top: -24px">
                                        <i class="fa fa-phone text-success mr-2"></i>
                                        <strong>24/7 Support &bull;</strong>
                                        <span>We're here to help. </span>
                                        <a href="/contact-us">Contact us if you need help.</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="d-block d-lg-none text-center">
                                <h1 class="text-6 font-weight-700 text-primary mb-3">
                                    <span>{{ service || 'Experience Lightning Fast Bill Payments!' }}</span>
                                </h1>
                                <p class="text-1 text-black-50 mb-4">
                                    Magetsi is a digital omni-channel platform that provides an array of payment
                                    services through web, WhatsApp, Facebook, and other channels.
                                </p>
                            </div>
                            <div class="overflow-hidden">
                                <div class="card-body bg-primary text-white mb-4 rounded-lg">
                                    <div class="d-flex align-items-center mb-3">
                                        <h3 class="h5 text-white mr-auto">Which Service Are You Looking For?</h3>
                                    </div>
                                    <div class="rounded d-flex align-items-center position-relative mb-3 bg-white-50 p-2">
                                        <i class="fa fa-search px-3"></i>
                                        <div class="flex-grow-1">
                                            <input type="search" v-model="search" style="height: auto"
                                                   placeholder="Search..."
                                                   class="form-control-sm text-white form-control border-0 bg-transparent">
                                        </div>
                                        <button style="height: auto"
                                                class="btn bg-transparent text-white border-0 shadow-none btn-sm">
                                            <i class="fa fa-arrow-right"></i>
                                        </button>
                                    </div>
                                    <horizontal-scroll icons-placement="sides">
                                        <template v-for="(provider, index) in providers">
                                            <button v-if="provider" :key="'prov' + index" @click="search = provider"
                                                    :aria-labelledby="`tag: ${provider}`"
                                                    class="btn btn-outline-light bg-white-50 border-0 px-4 py-1 rounded-pill mr-2 shadow-none">
                                                <i class="fa small fa-tag mr-1"></i>
                                                <small>{{ provider }}</small>
                                            </button>
                                        </template>
                                    </horizontal-scroll>
                                </div>
                                <div class="row">
                                    <div v-for="(item, index) in filteredServices" class="col-md-6 col-6">
                                        <template>
                                            <router-link v-if="item.route !== '#'" :to="item.route" class="d-block mb-3">
                                                <div
                                                    class="d-flex align-items-center px-3 py-2 border rounded-lg bg-white shadow-sm service-card"
                                                    style="min-height: 80px; max-height: 80px; width: 100%;">
                                                    <img v-if="item.icon" height="36" class="img-gray mr-3"
                                                         :src="`/img/service-icons/${item.icon}`" alt="">
                                                    <div class="flex-grow-1">
                                                        <div class="font-weight-bold text-left text-muted mb-1">
                                                            {{ item.title }}
                                                        </div>
                                                        <small class="text-black-50 d-none d-md-block">
                                                            {{ item.subtitle }}
                                                        </small>
                                                    </div>
                                                    <i class="fa fa-arrow-right text-muted ml-3 d-none d-md-block"></i>
                                                </div>
                                            </router-link>
                                        </template>
                                    </div>
                                </div>
                                </div>
                                <div class="text-center mt-2">
                                    <a href="/zesa" class="btn btn-danger px-3 py-3 btn-block bg-accent mb-3 rounded">
                                        Buy ZESA Token
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-white">
            <div class="container">
                <h2 class="text-9 text-center font-weight-bold text-primary" data-aos-delay="250" data-aos="fade-in">
                    Why choose us?
                </h2>
                <p class="text-4 text-center font-weight-300 mb-5" data-aos-delay="250" data-aos="fade-in">
                    Choosing a payment option should never be done lightly, as it’s not just about transactions; it’s
                    about
                    your time, your peace of mind, and your hard-earned money. Magetsi acknowledges these concerns, and
                    we
                    have crafted our platform to address them head-on. Here are the reasons why Magetsi stands head and
                    shoulders above the rest:
                </p>
                <div class="row mb-4">
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-hand-pointer"></i>
                            </div>
                            <h3 class="font-weight-400">Unrivalled Convenience</h3>
                            <p>
                                With Magetsi, geographical boundaries or office hours don't limit you. Our platform
                                empowers you to pay for your ZESA tokens and airtime, and make bill payments
                                anytime, anywhere, and via your preferred payment method. Whether you're at home, at
                                work, or on the go, Magetsi is right there with you.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-share"></i>
                            </div>
                            <h3 class="font-weight-400">Top-Notch Security</h3>
                            <p>
                                At Magetsi, we take the security of your financial information seriously. We have
                                integrated state-of-the-art security protocols to ensure that every transaction you
                                make and every piece of data you entrust us with is safeguarded. This commitment to
                                security gives you peace of mind and enables a worry-free transaction experience.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-dollar-sign"></i>
                            </div>
                            <h3 class="font-weight-400">Superior Customer Service</h3>
                            <p>
                                Service that truly serves—that's what Magetsi's dedicated customer service team
                                offers. With a laser focus on addressing your needs and solving your problems, we're
                                always here to assist you, be it queries, concerns, or any other form of assistance
                                you need with your payments.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-lock"></i>
                            </div>
                            <h3 class="font-weight-400">Versatile Payment Options</h3>
                            <p>
                                Your preferred payment method is our command. Whether you prefer EcoCash,
                                Mastercard, Visa, or any other payment method, Magetsi accommodates them all. This
                                versatility allows you to choose a payment method that best suits your needs.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-user-friends"></i>
                            </div>
                            <h3 class="font-weight-400">User-Friendly Experience</h3>
                            <p>
                                Magetsi's platform is meticulously designed with you in mind. The intuitive
                                interface is easy to navigate and simplifies the process of buying ZESA tokens,
                                purchasing airtime, and making bill payments.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-star"></i>

                            </div>
                            <h3 class="font-weight-400">Proven Track Record</h3>
                            <p>
                                Our sterling reputation precedes us. We are proud of the trust our customers have
                                placed in us, reflected in our high customer satisfaction ratings. Our exemplary
                                customer service ensures that should you encounter any hiccups, our team will be on
                                hand to promptly resolve them.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-4">
                        <div class="featured-box style-3" data-aos-delay="250" data-aos="fade-in">
                            <div class="featured-box-icon border border-primary text-primary rounded-circle">
                                <i class="fas fa-chart-line"></i>
                            </div>
                            <h3 class="font-weight-400">Commitment to Evolution</h3>
                            <p>
                                As a vibrant startup, Magetsi embraces the ethos of continuous improvement. We are
                                constantly learning, refining, and adapting our platform in response to your needs.
                                For us, it's not just about growing a successful business; it's about enhancing your
                                experiences and making a lasting, positive impact on your lives.
                            </p>
                        </div>
                    </div>
                </div>
                <p class="text-4 text-center font-weight-300 mb-5" data-aos-delay="250" data-aos="fade-in">
                    At Magetsi, we recognize that the road to perfection is a journey, not a destination. And as a
                    startup,
                    we may not always get it right, but our dedication to continuously refine and adapt is unwavering.
                    Above
                    all, we aim to ensure that you, our valued customers, receive the exceptional service you expect and
                    deserve. Your satisfaction is our ultimate success.
                </p>
            </div>
        </section>
    </main>
</template>

<script>
import {navigationComponents} from "../../core/navigation-components";
import HorizontalScroll from "../core/horizontal-scroll.vue";
import {appDataMixin} from "../../core/data/global";
import {increment} from "../../core/utils/increment";

export default {
    name: "dashboard",
    components: {HorizontalScroll},
    mixins: [navigationComponents, appDataMixin],
    data: () => ({
        service: '',
        serviceIndex: 0,
        search: '',
        title: '',
    }),
    methods: {
        nextService() {
            const services = Object.values(this.flatServices);
            const service = services[this.serviceIndex];
            const serviceName = service.displayName;

            increment({
                text: serviceName,
                interval: 100,
                setText: (text) => this.service = text + '|',
                complete: () => {
                    this.service = serviceName;
                    this.serviceIndex = (this.serviceIndex + 1) % services.length;
                    this.title = `Buy ${serviceName} Online`

                    setTimeout(() => this.nextService(), 7000)
                }
            })
        },
    },
    computed: {
        imageIndex() {
            return Math.floor(Math.random() * 5) + 7
        },
        searchedServices() {
            return this.flatServicesList
                .filter(service => service.displayName.toLowerCase().includes(this.search.toLowerCase()))
                .map(service => ({
                    route: service.route,
                    title: service.displayName,
                    image: service.image,
                    subtitle: service.description,
                }));
        },
        filteredServices(){
            return (this.search ? this.searchedServices : this.menu)
        },
    },
    mounted() {
        setTimeout(() => this.nextService(), 10000)
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        let context = params.get('context');
        if (context) {
            if (context === "stripe-batch") {
                let ref = params.get('ref');
                if (ref) {
                    this.$router.push(`/business/stripe?ref=${ref}`);
                }
            }

            if (context === "stripe") {
                let id = params.get('id');
                let type = params.get('type');

                if (id && type) {
                    if (type === "zesa") {
                        this.$router.push(`/zesa/stripe?id=${id}`);
                    }

                    if (type === "airtime") {
                        this.$router.push(`/airtime/stripe?id=${id}`);
                    }

                    if (type === "bundles") {
                        this.$router.push(`/bundles/stripe?id=${id}`);
                    }

                    if (type === "telone") {
                        this.$router.push(`/telone/stripe?id=${id}`);
                    }
                    if (type === "ticket-purchase")
                    {
                        this.$router.push(`/tickets/stripe?id=${id}`);
                    }
                    if (type === "biller-payment")
                    {
                        this.$router.push(`/billers/stripe?id=${id}`);
                    }
                    if (type === "wallet-deposit")
                    {
                        this.$router.push(`/business/wallets/deposit/stripe?id=${id}`);
                    }
                }
            }
        }
    },

}
</script>

<style scoped>
.services-section {
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding: 0 0 0 0;
    z-index: 1;
}

.services-section img {
    height: 36px;
    width: 36px;
    opacity: 0.75;
}

.payment-logo {
    height: 46px;
    padding: 0.8rem;
    background-color: white;
    opacity: 0.75;
    border-radius: 6px;
    margin-right: 1rem;
    margin-bottom: 1rem;
    object-position: center;
    object-fit: contain;
    border: 1px rgba(170, 170, 170, 0.2) solid;
}


.currency-switch-icon {
    height: 16px;
    width: 24px;
    object-fit: cover;
    border-radius: 3px;
    margin-left: 0.5rem;
    cursor: pointer;
    opacity: 0.5;
}

.currency-switch-icon:hover {
    border: 1px rgba(255, 255, 255, 0.45) solid;
    transition: all 250ms ease-in-out;
    transform: scale(1.01);
}

.currency-switch-icon.active {
    border: 1px #fff solid;
    opacity: 1;
}

.row.no-gutters {
    margin-left: 0;
    margin-right: 0;
}


.d-block.mb-2 {
    margin-bottom: 15px;
}

.card-body.mb-3 {
    margin-bottom: 20px;
}
.service-card {
    width: 95%;
    height: auto;
    padding: 15px 20px;
    margin-left: auto;
    margin-right: auto;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.row.no-gutters {
    margin-left: 0;
    margin-right: 0;
}


</style>
